import colors from "common/constants/colorsOld";
import { sheetInchesNew, sheetPointsNew, worldInchesNew } from "common/utils/nominalNumbers";

// Filepaths
export const filepathHigharcArchImage = "/static/logos/higharc-arch.png";
export const filepathHigharcTextImage = "/static/logos/higharc-bw-text.png";
export const filepathHigharcLogo = "/static/logos/higharc-logo-horizontal-10x.png";

// Text
export const textAddress = `100 School St`;

export function textLiabilityDisclaimer(builderName: string): string {
  const disc =
    "Higharc, Inc. is not an architectural firm nor are the artistic representations contained herein intended to be construed as ready-to-use architectural plans, construction documents, drawings, renderings, or any other similar or related documents. All drawings are artist’s representations only and solely intended to reflect design intent derived exclusively from the home building plans and associated information, data, and specifications provided by " +
    builderName +
    ". Higharc, Inc. is not responsible, nor may it be held liable for any errors or omissions contained herein or resulting from its usage. Any usage of the representations should be reviewed by local professionals to ensure conformance with local and state codes and be field verified prior to the start of any construction.";

  return disc;
}

export const LW_EXTRA_THIN = sheetPointsNew(0.2);
export const LW_THIN = sheetPointsNew(0.4);
export const LW_MEDIUM = sheetPointsNew(0.6);
export const LW_BOLD = sheetPointsNew(1.0);
export const LW_EXTRA_BOLD = sheetPointsNew(1.2);
/**
 * Default weight for the elevation grade line, heavier than the rest of the sheet's linework. Its
 * own constant rather than LW_EXTRA_BOLD so it can be tuned without affecting other categories.
 *
 * Applies to both grade line sources, and is deliberately lighter than what the flat grade line
 * drew before: that was a filled band roughly 7.4pt tall hanging below grade, which was a fill
 * height rather than a line weight and exceeded the heaviest width the style picker offers. 2pt is
 * a selectable width and matches what drafters reach for on a hand-drawn grade line, so all three
 * -- default, modeled, and manual annotation -- now read the same.
 */
export const GRADE_LINE_STROKE_WIDTH = sheetPointsNew(2);

export const TEXT_STROKE_WIDTH = sheetPointsNew(2);

export const PROP_COLOR = colors.stone;

// perspective
export const LW_PERSP = sheetPointsNew(0.7);
export const LW_HATCH = sheetPointsNew(0.35);

// labels and fonts
export const FOUNDATION_DIM_OFFSET_MULTIPLIER = 0.8;
export const FOUNDATION_TAG_WIDTH = worldInchesNew(24);

// lineweights
export const DIM_LW = LW_EXTRA_THIN;
export const DIM_TICK_LW = LW_THIN;

/**
 * @deprecated - use LW_BOLD instead if you must use a direct LW value.
 * Preferred pattern is to attach a style to the geometry category
 */
export const WALL_CUT_STROKE_WIDTH = LW_BOLD;

export const DASHED_LW = LW_THIN;

export const CASEWORK_LINE_WIDTH = LW_EXTRA_THIN;
export const STAIR_LW = LW_EXTRA_THIN;

const date = new Date();
const month = date.getMonth() + 1;
const day = date.getDate();
const year = date.getFullYear();

export let PDF_TITLE_BLOCK_DATE_STRING_OVERRIDE: string | undefined = undefined;

export function setPDFTitleBlockDateStringOverride(value: string) {
  PDF_TITLE_BLOCK_DATE_STRING_OVERRIDE = value;
}

export const DEFAULT_CREATION_DATE_OVERRIDE = "2021-07-21T06:06:17.721Z";

export const dateString = month.toString() + "/" + day.toString() + "/" + year.toString();

export const textCopyrightMark = "© " + year.toString() + " HIGHARC, INC";
// Labels
export const labelTextProject = "PROJECT";
export const labelTextDwgTitle = "DRAWING TITLE";
export const labelTextSheetNum = "SHEET NUMBER";
export const labelTextNotForConstruction = "NOT FOR CONSTRUCTION";

// Builders
export const epconBuilders = [
  "Epcon Homes",
  "Epcon OH - Foundation Development Group",
  "Epcon IA - Kelly Construction",
  "Epcon UT - Choice Builders Group",
  "Epcon MN - Villas At Pleasant LLC",
];

// Adjust this to make the drawings higher resolution.
export const DRAWING_RENDER_SCALE = 72;

export const PAGE_WIDTH_INCHES = sheetInchesNew(34);
export const PAGE_HEIGHT_INCHES = sheetInchesNew(22);
export const MARGIN_INCHES = sheetInchesNew(0.5);
export const MARGIN_LEFT_INCHES = sheetInchesNew(2);
